import React from "react";
import { Row, Col } from "reactstrap";
import Person from "../components/person";
import CircleTimer from "../../../components/circleTimer";
import _ from "lodash";
import cx from "classnames";
import Categoryimg from "../../../assets/images/tot/CATEGORY.png";

const TimeLeft = ({ count, time, activeGuesser, screenParams, gameState }) => {
  const timeLeftLabel =
    _.get(screenParams, "tot.guessing_time_left_label") || "Time Left";
  const guesserLabel =
    _.get(screenParams, "tot.guessing_guesser_label") || "Guesser";

    console.log(count , time , "CircleTimerCircleTimerCircleTimer")
    
  return (
    <div className="tot-50 tot-time-left py-0">
      <div className="tot-head-card h-100">
        <Row className="h-100">
          <Col lg={12} className="h-100">
            <div className="d-flex h-100 justify-content-between">
              <div className="h-100 tot-head-card d-flex flex-column justify-content-end pl-0 cardwidth">
                {/* <div className="head justify-content-center">
                <h2 className="text title">{guesserLabel}</h2>
              </div> */}
                <Person activeGuesser={activeGuesser} />
              </div>

              <div className="h-100 tot-head-card">
                {/* <div className="head justify-content-center">
                  <h2 className="text title">{timeLeftLabel}</h2>
                </div> */}
                <div className="timer-circle">
                  <CircleTimer tot count={count} time={time} />
                </div>
              </div>
              <div className="h-100 tot-head-card d-flex align-items-center tot-img-content">
                <div className="tot-images-wrapper ">
                  <div className="image-caption">
                    {/* <p>Category</p> */}
                    <img src={Categoryimg} alt="Category" />
                    <h4
                      className={cx({
                        smallFontSize:
                          gameState?.current_category ===
                          "Philosophy, Fables, Myths, and Legends",
                      })}
                    >
                      {(gameState && gameState.current_category) || ""}
                    </h4>
                  </div>
                  <img
                    src={(gameState && gameState.category_image) || ""}
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TimeLeft;
